import React, { useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import { useRestaurant } from '../contexts/restaurant.context';
import { hideMinimumCheckoutAlert } from '../store/actions/checkout.actions';
import { Modal } from './Modal';

function MinimumCheckoutAlert() {
    const dispatch = useDispatch();

    const restaurant = useRestaurant();
    const isShow = useSelector(state => state.checkout.isShowMinimumAlert);

    const handleCloseAlert = useCallback((e) => {
        dispatch(hideMinimumCheckoutAlert());
    }, [dispatch]);

    return (
        <Modal title="Warning!" onClose={handleCloseAlert} isOpen={isShow}>
            <p>Credit card order must be at least <span className="sold-out">${restaurant?.minimum_checkout_value?.toFixed(2)}</span></p>
        </Modal>
    )
}

export default MinimumCheckoutAlert;